import React, { FC } from 'react'

import { pluralize } from '@avantstay/backoffice-core'

import { filtersLabels } from '@new/domains/bookings/screens/bookingsList/utils/labels'

import { FiltersSharedProps } from './Filters.types'
import { InputBasedFilter } from './FiltersVariations/Input'

interface MinBedroomsFilterProps extends FiltersSharedProps {
  initialValue?: string
  onChange: (value?: string) => void
}

export const MinBedroomsFilter: FC<MinBedroomsFilterProps> = props => {
  const { initialValue } = props

  return (
    <InputBasedFilter
      title={filtersLabels.minBedroom}
      type="number"
      placeholder="0"
      {...props}
      tagSuffix={initialValue && pluralize(parseInt(initialValue, 10), 'bedrooms', 'bedroom')}
    />
  )
}
